import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout } from '@spotnana/blocks/src/Layout/Layout';
import CheckoutContainer from 'src/app/flights/shared/CheckoutContainer';
import TripDetails from 'src/v1-components/trips/details/shared/TripDetails';
import AdditionalInfoContainer from 'src/app/flights/ExchangeFlightCheckoutPage/AdditionalInfoContainer';
import BookingFailedAlertModalContainer from '../BookingFailedAlertModalContainer';
import FareChangeAlertModalContainer from '../FareChangeAlertModalContainer';
import TravelSummaryContainer from '../TravelSummaryContainer';
import PaymentOptionsContainer from '../PaymentOptions';
import FareContainer from '../FareContainer';
import ConfirmationButton from '../ConfirmationButton';
import { sticky_container } from '../../checkout/CheckoutFinalizePage/styles';
import { tripDetailsContainer } from '../styles';
import EmissionsInfoContainer from '../EmissionsInfoContainer';
import useDoneHandler from '../hooks/useDoneHandler';
import FareBreakupContent from '../FareBreakupContent';
import { IRetryPaymentParams } from '../types';
import { CvvInputContainer } from '../CvvInputContainer';
import { CheckoutCom3ds2ModalContainer } from '../CheckoutCom3ds2ModalContainer/CheckoutCom3ds2ModalContainer';
import { RazorPayAuthModalContainer } from '../RazorPayAuthModalContainer';

const RetryPaymentCheckoutPageContent: FC = () => {
  useDoneHandler();
  const history = useHistory();
  const { t: tt } = useTranslation('WEB');

  const { tripId } = useParams<IRetryPaymentParams>();

  const handleBackToTripsClick = () => {
    history.replace(`/trips/${tripId}`);
  };

  return (
    <>
      <CheckoutContainer
        backButtonText={tt('Back to your trip')}
        onBack={handleBackToTripsClick}
        title={tt('Retry Payment')}
        airSelectedItineraryResponseManager={null}
        itineraryOwner={null}
        shouldShowAddToItineraryList={false}
      >
        <Layout.Row spacing="1">
          <Layout.Col desktop="8" mobile="12">
            <TripDetails tripId={tripId} css={tripDetailsContainer} />
            <TravelSummaryContainer />
            <PaymentOptionsContainer />
          </Layout.Col>

          <Layout.Col desktop="4" mobile="12">
            <div css={sticky_container}>
              <FareContainer>
                <FareBreakupContent />
                <CvvInputContainer />
                <ConfirmationButton />
              </FareContainer>
              <AdditionalInfoContainer />
              <EmissionsInfoContainer />
            </div>
          </Layout.Col>
        </Layout.Row>
      </CheckoutContainer>

      {/* Rendered by state machine guards */}
      <BookingFailedAlertModalContainer />
      <FareChangeAlertModalContainer />
      <CheckoutCom3ds2ModalContainer />
      <RazorPayAuthModalContainer />
    </>
  );
};

export default RetryPaymentCheckoutPageContent;
